import React from "react";
import  {
  Page,
  Text,
  View,
  Document,
  BlobProvider,
} from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { Spin } from "antd";
import { receipts_styles as styles, PDFSaved} from './PDF_Helper'


const DisplayContent = props => {
  return props.data.map(item => {
    let OrgName = sessionStorage.getItem("OrganisationName");
    let Address = sessionStorage.getItem("Address");
    return (
      <View key={item.offeringNo} style={styles.content} wrap={false}>
        <Text style={styles.heading}>{OrgName}</Text>
        <Text style={styles.address}>{Address}</Text>
        <Text style={styles.title}>Tax Certificate</Text>
        <View style={styles.detailContainer}>
          <Text style={styles.label}>Reference :</Text>
          <Text style={styles.engDetails}>
         {item.offeringNo}
        </Text>
        </View>
        <View style={styles.detailContainer}>
          <Text style={styles.label}>Received from :</Text>
          <Text style={styles.chnDetails}>
          {item.displayName}{" "}
        </Text>
        </View>
        <View style={styles.detailContainer}>
          <Text style={styles.label}>This receipt covers donations for the period:</Text>
          <Text style={styles.engDetails}>
          {item.fromDate} to {item.toDate}
        </Text>
        </View>
        <View style={styles.detailContainer}>
          <Text style={styles.label}>Total received:</Text>
          <Text style={styles.engDetails}>
          ${item.totalAmount.toFixed(2)}
        </Text>
        </View>
        <View style={styles.detailContainer}>
          <Text style={styles.signLabel}></Text>
          <Text style={styles.sign}>Sign:</Text>
        </View>

      </View>
    );
  });
};

const GetPDF = props => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <DisplayContent data={props.data} />
      </Page>
    </Document>
  );
};

export default function CreateAndSavePDF(props) {

  if (props.ready) {
    let endDate = props.data[0].toDate.replace(/\//g,'_')
    return (
      <BlobProvider document={<GetPDF data={props.data} />}>
        {({ blob, url, loading, error }) => {
          //console.log(url);
          if (!loading && url) {
            //console.log("saving...");
            saveAs(blob, `tax_certificate_${endDate}.pdf`);
            //console.log("saved");
            //alert("downloaded")
            //intervalId = setInterval(doFinish, 200)
            return <PDFSaved doFinish={props.doFinish} />;
          }
          if (loading) {
            //console.log(`.....loading ${loading} ....`);
            return <Spin tip="loading" spinning={true} />;
          }
          if (error) {
            //console.error(error);
            return <p>An error occurred</p>;
          }

          return null;
        }}
      </BlobProvider>
    );
  }
  return null;
}

